import React, { useRef, useEffect, useState } from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, BankFilled, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Table, Empty, Modal, Divider, Button, message, Space, Tag } from 'antd';
import { getAllCompanies, getCompaniesList } from '../../../../apis/OdooApi';
import _ from 'lodash'
import ModalUploadFiles from './Upload';

const { confirm } = Modal;

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <BankFilled />
        <span>Certificados</span>
      </>
    ),
  }
];

const CompaniaPage = () => {
  const [companies, setCompanies] = React.useState([]);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const [openUploadFiles, setOpenUploadFiles] = useState(false);

  const openUploadModal = async (company) => {
    setSelectedCompany(company);
    setOpenUploadFiles(true);
  }

  const columns = [
    {
      title: 'ID Odoo',
      dataIndex: 'odoo_id',
      key: 'odoo_id',
      width: 180,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <span style={{ fontWeight: 'bold' }}>{text}</span>
      )
    },
    {
      title: 'RFC',
      dataIndex: 'vat',
      key: 'vat',
      render: (vat) => vat ? <Tag color="blue">{vat}</Tag> : '-'
    },
    {
      title: 'Estado',
      dataIndex: 'activo',
      key: 'activo',
      render: (activo) => (
        <Tag color={activo ? 'green' : 'red'}>
          {activo ? 'Activo' : 'Inactivo'}
        </Tag>
      )
    },
    {
      title: 'Certificados',
      dataIndex: 'tiene_certificados',
      key: 'tiene_certificados',
      width: 130,
      render: (tiene_certificados) => (
        tiene_certificados ? (
          <Tag color="green" icon={<CheckCircleOutlined />}>
            Configurado
          </Tag>
        ) : (
          <Tag color="orange" icon={<ExclamationCircleOutlined />}>
            Pendiente
          </Tag>
        )
      )
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      key: 'actions',
      width: 180,
      render: (_, record) => (
        <Space>
          <Button
            type={record.tiene_certificados ? 'default' : 'primary'}
            size='small'
            onClick={() => openUploadModal(record)}
            icon={record.tiene_certificados ? <CheckCircleOutlined /> : <ExclamationCircleOutlined />}
          >
            {record.tiene_certificados ? 'Actualizar Certificados' : 'Subir Certificados'}
          </Button>
        </Space>
      )
    }
  ];

  const openDetails = async (company) => {
    setOpenEdit(true);
    setSelectedCompany(company);
  }

  const onHandlerFinish = async (refresh, avoidClose) => {
    if (!avoidClose) {
      setOpenEdit(false);
    }

    if (refresh) {
      await refreshData();
    }
  }

  const refreshData = async () => {
    try {
      const response = await getAllCompanies();
      if (response.ok) {
        setCompanies(response.payload);
      } else {
        message.error('Error al cargar las compañías');
      }
    } catch (error) {
      message.error('Error de conexión');
    }
  }

  const effectRan = useRef(false);
  useEffect(() => {
    if (!effectRan.current) {
      refreshData();
    }
    return () => effectRan.current = true;
  }, []);

  return (
    <PageApp routes={routes} title={"Certificados"}>
      <Divider />
      {
        companies.length === 0 ?
          <Empty description="No hay certificados configurados" /> :
          <Table
            dataSource={companies}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
      }
      
      {openUploadFiles && selectedCompany && (
        <ModalUploadFiles
          title={`${selectedCompany.tiene_certificados ? 'Actualizar' : 'Subir'} Certificados para ${selectedCompany.name}`}
          open={openUploadFiles}
          finish={(refresh) => {
            setOpenUploadFiles(false);
            if (refresh) refreshData();
          }}
          data={selectedCompany}
        />
      )}
    </PageApp>
  );
}

export default CompaniaPage;